import { PdfHelper } from "../../../helpers/PdfHelper";

/* eslint-disable */
export default class PurchaseOrderPdf
{
    
    docRev = 'GM-ADF-06 REV:00';
    /**
     * print pdf
    */
    static printDocument(data)
    {
        const builder = new PurchaseOrderPdf();
        const document = builder.getDocument(data);
        PdfHelper.createPdf(document);
    }

    /**
     * open pdf
     */
    static openDocument(data)
    {
        const builder = new PurchaseOrderPdf();
        const document = builder.getDocument(data);
        PdfHelper.open(document);
    }





    

    getDocument(data) {
        const pdfHelper = new PdfHelper();
        const feePdf = new PurchaseOrderPdf();
       
        return {
            info: {
                title: `Orden de compra`,
                author: 'Chronos',
            },
            styles: pdfHelper.getStyles(),
            // a string or { width: number, height: number }
            pageSize: 'letter',
            // by default we use portrait, you can change it to landscape if you wish
            pageOrientation: 'portrait',
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins 
            pageMargins:[70,100,70,50],
            // header:  pdfHelper.getHeader("COTIZACIÓN", "COT00004", "2023/02/03"),
           
            header: function(currentPage, pageCount) { 
                return pdfHelper.getHeader(currentPage, data.data.purchase_order_id, data.data.date_pdf, data.data?.secondary_logo??"")
            },
            footer: function(currentPage, pageCount) { 
                return feePdf.getFooter(currentPage, pageCount, null, null, null, feePdf.docRev)
            },
            // absolutePosition: {x: 230, y: -15}
            content: [
               
                //header
                pdfHelper.getPrimaryHeader("ORDEN DE\nCOMPRA", data.data.purchase_order_id, data.data.date_pdf, data.data.primary_logo, 30),
                

                // //tanks
                this.getThanks(data.data?.address??"", data.data?.email??"", data.data?.phone??"", data.data?.supplier??""),

                // //table
                this.getTable(data.supplies),
                this.getSummaryTable(data.supplies),

                //comments
                this.getCommentsSpecVig(data.data.comments_pdf)
                            
            ],
            
            
            
        
        };
    }

    getCommentsSpecVig(comments)
    {
        let commentTitle = "OBSERVACIONES:"
        
        let items = [];
        //comments
        if(comments != null && comments.length > 0){
            items.push(
                {
                    text:`${commentTitle} `,
                    style:['footerComentaryTitle']
                },
                
            )
            if(Array.isArray(comments)){
                comments.forEach(item => {
                    items.push(
                        {
                            text:`${item} `,
                            style:['marginFooterMessages'],
                        },
                    );
                });
            }else{
                items.push(
                    {
                        text:`${comments} `,
                        style:['marginFooterMessages'],
                    },
                );
            }
            
        }
       

        return [
            //comments, conditions & validity
            {
                margin:[0,5,0,0],
                style:['footerMessage'],
                stack:[
                    ...items,
                    
                ]
            },
        ]
    }

    getFooterSize(comments, conditions)
    {
        return 24;
        // //no comments no conditions
        // if((comments === "" || comments === null) && (conditions === "" || conditions === null))
        //     return 164;
        // //no comments with conditions
        // if((comments === "" || comments === null) && (conditions !== "" && conditions !== null))
        //     return 180;
        // //no condition with comments
        // if((conditions === "" || conditions === null) && (comments !== "" && comments !== null))
        //     return 199;
        // //default 
        // return 210;

        
    }

    getFooter(currentPage, pageCount, address_data, phone, email, revDoc = '')
    {
        const pdfHelper = new PdfHelper();
        

        // if(currentPage === 1 && pageCount != 1)
        //     return {};
        if(currentPage === pageCount){
            return [
                //bottom line
                {
                    absolutePosition: {x: 0, y: 0},
                        canvas: 
                       [
                          
                           {
                                type: 'polyline',
                                lineWidth: 3,
                                closePath: true,
                                color: '#005e7f',
                                lineColor: '#005e7f',
                                points: [{ x: 0, y: 45 }, { x: 0, y: 60 }, { x: 1000, y: 60}, { x: 1000, y: 45 }]
                            },
                           
                       ]
                },
                
                


                //contact info
                pdfHelper.getContactInfo(revDoc),
            
            ];
        }
        return {};

    }

    

    getFooterSpace(hSize)
    {
        return  {
            unbreakable: true,          
            columns: [
                
                {
                    canvas:[
                        {
                            type: 'rect',
                            x: 20,
                            y: 0,
                            w: 1,
                            h: hSize,
                            r: 5,
                            
                            // lineWidth: 10,
                            lineColor: '#000',
                        },
                    ]
                }
             ],
             columnGap: 10,
        };
    }

    getThanks(address, email, phone, supplier){
       
        // \n
        return [
            {
                style:['marginTanks'],
                layout:  {
                    hLineWidth: function (i, node) {
                        return 3
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    },
                    hLineColor: function (i, node) {
                        return '#fff'
                    },
                    
                },
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            {
                                text: `PROVEEDOR\n${supplier}`,
                                style:['poInformation'],
                            },
                            {
                                text: `TELÉFONO\n${phone}`,
                                style:['poInformation'],
                            }
                        ],
                        [
                            {
                                text: `DIRECCIÓN\n${address}`,
                                style:['poInformation'],
                            },
                            {
                                text: `CORREO\n${email}`,
                                style:['poInformation'],
                            }
                        ],
                        
                    ]
                }
            }
        ];
    }


    getTable(items)
    {
        //table items
        const tableItems = [];

        let importe = 0;
        items.forEach((item, index) => {
            importe = item.quantity * parseFloat(''+item.amount);
            tableItems.push(
                [
                    {
                        text:`${index+1}`,
                        style:['tableItemSecondary', 'tableItemSecondaryFirst'],
                    },
                    {
                        text:`${item.name}`,
                        style:['tableItemPrimary'],
                    },
                    
                    {
                        text:`${item.quantity}`,
                        style:['tableItemSecondary', 'tableItemSecondaryMargin']
                    },
                    {
                        text:`$${parseFloat(''+item?.amount??'0').toFixed(2)}`,
                        style:['tableItemSecondary', ],
                    },
                    {
                        text:`$${parseFloat(''+importe).toFixed(2)}`,
                        style:['tableItemSecondary', 'tableItemSecondaryMarginLast', 'marginTableItems', 'alignRight'],
                    }
                ],
            )
        });


        return {
            margin:[0,0,0,0],
            layout:  {
                hLineWidth: function (i, node) {
                    if(i === 1)
                        return 3;
                    return 3
                },
                vLineWidth: function (i, node) {
                    return 0;
                },
                hLineColor: function (i, node) {
                    if(i === 1)
                         return '#005e7f'
                    return '#fff'
                },
                //paddingLeft: function(i, node) { return 40; },
                //paddingBottom: function(i, node) { return 20; },
                // fillColor: function (rowIndex, node, columnIndex) {
                //     if(rowIndex === 0)
                //         return '#F2F2F2';
                    
                    
                //     return (rowIndex % 2 === 0) ? '#FFFFFF' : "#FCFCFC";
                // }
            },
            table:{
                headerRows: 1,
                widths: [ 20, '*', 80,80,80 ],
                heights: [10, 10, 10,10, 10],
                body:[
                    //headers
                    [
                        {
                            text:"#",
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7],
                        },
                        {
                            text:"Producto",
                            style:['tableHeaderFont'],
                            margin:[0,0,0,7]
                        },
                        
                        {
                            text:"Cantidad",
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7]
                        },
                        {
                            text:`Costo`,
                            style:['tableHeaderFont','alignCenter'],
                            margin:[0,0,0,7]
                        },
                        {
                            text:`Subtotal`,
                            style:['tableHeaderFont','alignRight'],
                            margin:[0,0,0,7]
                        }
                    ],
                    //items
                    ...tableItems,
                ]
            }
        }
    }

    getSummaryTable(items)
    {
        let subtotal = 0;
        
        items.forEach((item, index) => {
            subtotal = subtotal + (item.quantity * parseFloat(item.amount));
        });

        const iva = (16 * subtotal) / 100;
        const total = subtotal.toFixed(2);
        const grandTotal = iva + subtotal;



        return{
            margin:[0,10,0,0],
            layout:  {
                hLineWidth: function (i, node) {
                    
                    return 1
                },
                vLineWidth: function (i, node) {

                    return 0;
                },
                hLineColor: function (i, node,columnIndex) {
                    // console.log(i, columnIndex)
                    if(i === 2 && columnIndex === 2)
                            return '#0C5394';
                    if(i === 2 && columnIndex === 1)
                            return '#0C5394';
                    return '#fff'
                },
                //paddingLeft: function(i, node) { return 40; },
                //paddingBottom: function(i, node) { return 20; },
                // fillColor: function (rowIndex, node, columnIndex) {
                //     if(rowIndex === 0)
                //         return '#F2F2F2';
                    
                    
                //     return (rowIndex % 2 === 0) ? '#FFFFFF' : "#FCFCFC";
                // }
            },
            table:{
                
                widths: [ '*',60,60 ],
                // heights: [10, 10, 10],
                body:[
                    
                    [
                        {
                            text:"",
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        },
                        {
                            text:"SUBTOTAL:",
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight', 'bold'],
                            margin:[0,0,0,1],
                        },
                        {
                            text: `$${total}`,
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        }
                        
                    ],
                    [
                        {
                            text:"",
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        },
                        {
                            text: `IVA:`,
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight', 'bold'],
                            margin:[0,0,0,1],
                        },
                        {
                            text:`$${parseFloat(''+iva).toFixed(2)}`,
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        },
                    ],
                    [
                        {
                            text:"",
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        },
                        {
                            text: `TOTAL:`,
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignLeft', 'bold'],
                            margin:[0,0,0,1],
                        },
                        {
                            text:`$${parseFloat(''+grandTotal).toFixed(2)}`,
                            style:['tableItemSecondary', 'tableSummaryMargin', 'alignRight'],
                            margin:[0,0,0,1],
                        }
                    ]
                ]
            }
        }
    }
}